
export const GETUSER = 'GETUSER'
export const GETUSERS = 'GETUSERS'
export const CREATEUSER = 'CREATEUSER'
export const REMOVEUSER = 'REMOVEUSER'
